var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemVariantsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12918 1.5H15.3875C17.3919 1.5 19.0167 3.12484 19.0167 5.12918V15.3875C19.0167 17.3919 17.3919 19.0167 15.3875 19.0167H5.12918C3.12484 19.0167 1.5 17.3919 1.5 15.3875V5.12918C1.5 3.12484 3.12484 1.5 5.12918 1.5Z",
    stroke: "#273E52",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8719 0H29.6136C26.7808 0 24.4844 2.29641 24.4844 5.12918V15.3875C24.4844 18.2203 26.7808 20.5167 29.6136 20.5167H39.8719C42.7047 20.5167 45.0011 18.2203 45.0011 15.3875V5.12918C45.0011 2.29641 42.7047 0 39.8719 0Z",
    fill: "#273E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5011 34.7427C43.5011 39.5798 39.5798 43.5011 34.7427 43.5011C29.9056 43.5011 25.9844 39.5798 25.9844 34.7427C25.9844 29.9056 29.9056 25.9844 34.7427 25.9844C39.5798 25.9844 43.5011 29.9056 43.5011 34.7427Z",
    stroke: "#273E52",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2584 45.0011C15.9239 45.0011 20.5167 40.4083 20.5167 34.7427C20.5167 29.0772 15.9239 24.4844 10.2584 24.4844C4.59282 24.4844 0 29.0772 0 34.7427C0 40.4083 4.59282 45.0011 10.2584 45.0011Z",
    fill: "#273E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemVariantsLogo);
export default __webpack_public_path__ + "static/media/item-variants-logo.67f1d805683ba39dbc49043137b0a956.svg";
export { ForwardRef as ReactComponent };